import React from 'react';
import styles from './modal.module.css';

const Modal = (props) =>
  props.show && <div className={`${styles.show} center`}>{props.children}</div>;

export default Modal;
